import Vue from 'vue'

const mutations = {
  SET_SCHEDULE: (state, payload) => {
    state.schedule[payload.type] = payload.val;
  },
  SET_START_AVAILABLE_DATE: (state, payload) => {
    state.startAvailableDate[payload.type] = payload.val;
  },
  SET_ADDRESS: (state, payload) => {
    state.addressItems[payload.type] = payload.val;
  },
  SET_FILTER_DATE_MODEL: (state, payload) => {
    state.filterDate = payload;
    Vue.set(state.urlDate, 'date', payload);
  },
  SET_FILTER_ADDRESS_MODEL: (state, payload) => {
    state.filterAddress = payload;
    Vue.set(state.urlDate, 'address', payload);
  },
  SET_FILTER_SEARCH_MODEL: (state, payload) => {
    state.filterSearch = payload;
    Vue.set(state.urlDate, 'search', payload);
  },
  SET_URL: (state, payload) => {
    state.urlDate = payload;
  },
  SET_AVAILABLE_DATE: (state, payload) => {
    state.availableDate = payload;
  }
};

export default {
  ...mutations
}